module.exports = __webpack_public_path__ + "img/24.b2612439.jpg";